import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { fetchClient, formatHeaders } from '@nike/fetch-client';
import { DOTCOM_UX_ID } from '@nike/ux-tread-dotcom-constants';
import getWebShellClientLocale from "../../../../../utils/get-webshellclient-locale";
import trackEvent from "../../../../../analytics/track-event";
import createCart from "../api-calls/create-cart";
import getCartQueryKey from "../get-query-key";
import isCartNotFoundError from "../utils/is-cart-not-found-error";
import getURLBase from "../utils/get-url-base";
import handleCartErrors from "../utils/handle-errors";
import handleCartWarnings from "../utils/handle-warnings";
var getFetchCartOptions = function getFetchCartOptions(_ref) {
  var queryClient = _ref.queryClient;
  return {
    queryKey: getCartQueryKey({
      queryClient: queryClient
    }),
    queryFn: function () {
      var _queryFn = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _window, _window2, _yield$Promise$all, _yield$Promise$all2, token, _yield$Promise$all2$, _yield$Promise$all2$2, visitId, visitorId, _getWebShellClientLoc, country, localeForCurrency, dataPromise, result, _t;
        return _regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 1;
              return Promise.all([(_window = window) === null || _window === void 0 || (_window = _window.webShellClient) === null || _window === void 0 || (_window = _window.identity) === null || _window === void 0 ? void 0 : _window.getAccessToken(), (_window2 = window) === null || _window2 === void 0 || (_window2 = _window2.webShellClient) === null || _window2 === void 0 || (_window2 = _window2.identity) === null || _window2 === void 0 ? void 0 : _window2.getVisitData()]);
            case 1:
              _yield$Promise$all = _context.sent;
              _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
              token = _yield$Promise$all2[0];
              _yield$Promise$all2$ = _yield$Promise$all2[1];
              _yield$Promise$all2$2 = _yield$Promise$all2$ === void 0 ? {} : _yield$Promise$all2$;
              visitId = _yield$Promise$all2$2.visitId;
              visitorId = _yield$Promise$all2$2.visitorId;
              _getWebShellClientLoc = getWebShellClientLocale(), country = _getWebShellClientLoc.country, localeForCurrency = _getWebShellClientLoc.hreflang;
              _context.next = 2;
              return fetchClient("".concat(getURLBase()), {
                headers: formatHeaders({
                  token: token,
                  visitId: visitId,
                  visitorId: visitorId,
                  appId: DOTCOM_UX_ID
                }),
                method: 'GET',
                credentials: 'include'
              }, 'Error retrieving data from carts by filters.', {
                pageActionName: 'tread-cart-event'
              });
            case 2:
              dataPromise = _context.sent;
              trackEvent('nike-shop-cart-fetched', null, {
                telemetryData: {
                  country: country,
                  localeForCurrency: localeForCurrency,
                  operationName: 'getCart'
                },
                usePageAction: true
              });

              // Handle warnings if present in the response
              if (!(dataPromise !== null && dataPromise !== void 0 && dataPromise.warnings && dataPromise.warnings.length > 0)) {
                _context.next = 3;
                break;
              }
              _context.next = 3;
              return handleCartWarnings({
                warnings: dataPromise.warnings,
                data: dataPromise
              }, queryClient);
            case 3:
              return _context.abrupt("return", dataPromise);
            case 4:
              _context.prev = 4;
              _t = _context["catch"](0);
              if (!isCartNotFoundError(_t)) {
                _context.next = 5;
                break;
              }
              return _context.abrupt("return", createCart());
            case 5:
              _context.next = 6;
              return handleCartErrors({
                error: _t,
                params: {}
              }, queryClient);
            case 6:
              result = _context.sent;
              return _context.abrupt("return", result.data);
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 4]]);
      }));
      function queryFn() {
        return _queryFn.apply(this, arguments);
      }
      return queryFn;
    }(),
    meta: {
      dispatchCartUpdated: true,
      dispatchCartCountUpdated: true
    },
    staleTime: Infinity
  };
};
export default getFetchCartOptions;